import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
  >
    <path
      d="M9 0.479238L5.01498 4.521L1 0.479238"
      stroke="#6A6783"
      strokeMiterlimit="10"
    />
  </svg>,
  "ChevronDown"
);
